import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue'
import { UseCaseContent } from '@/ui/microtrend/use-cases/use-cases.types'
import TmButton from '@/ui/tm-button/tm-button.vue'
import { object, string } from 'yup'
import { UseCaseFormTextContent } from '@/ui/microtrend/use-cases/use-case-form/use-case-form.types'
import TmRichTextEditor from '@/ui/tm-richt-text-editor/tm-rich-text-editor.vue'

interface Props {
  textContent: UseCaseFormTextContent
  submitCallback: (content: UseCaseContent) => Promise<void>
  cancel: () => Promise<void>
  cancelable: boolean
  content: UseCaseContent
}

interface FormValidation {
  validated: boolean
  hasErrors: boolean
  errors: {
    title: Array<string>
    text: Array<string>
  }
}


export default /*#__PURE__*/_defineComponent({
  __name: 'use-case-form',
  props: {
    textContent: null,
    submitCallback: null,
    cancel: null,
    cancelable: { type: Boolean },
    content: null
  },
  setup(__props: any) {

const props = __props as { textContent: UseCaseFormTextContent, submitCallback: (content: UseCaseContent) => Promise<void>, cancel: () => Promise<void>, cancelable: boolean, content: UseCaseContent }



const content = ref<UseCaseContent>(props.content)

const submitInProgress = ref<boolean>(false)

const schema = object().shape({
    title: string().required(props.textContent.title.validationErrors.required),
    text: string().required(props.textContent.text.validationErrors.required)
})

const formValidation = ref<FormValidation>({
    validated: false,
    hasErrors: false,
    errors: {
        title: [],
        text: []
    }
})

function validate (field: keyof FormValidation['errors']) {
    formValidation.value.validated = true

    schema
        .validateAt(field, content.value)
        .then(() => {
            formValidation.value.errors[field] = []
        })
        .catch(err => {
            formValidation.value.errors[field] = [err.message]
        })

    schema.validate(content.value)
        .then(() => {
            formValidation.value.hasErrors = false
        })
        .catch(() => {
            formValidation.value.hasErrors = true
        })
}

function handleKeyUp (field: keyof FormValidation['errors']): (event: KeyboardEvent) => void {
    return (event: KeyboardEvent): void => {
        event.key !== 'Tab' && validate(field)
    }
}

function submitButtonText (): string {
    if (props.cancelable) {
        return props.textContent.submitButton
    }

    return props.textContent.createButton
}

const handleTitleKeyUp = handleKeyUp('title')

async function submit (): Promise<void> {
    submitInProgress.value = true

    try {
        await props.submitCallback(content.value)
    } catch (e) {
        console.log('%cSubmitting use case service failed', 'color: red;')
    } finally {
        submitInProgress.value = false
    }
}

watch(
    () => props.content,
    (newValue) => {
        content.value = newValue

        if (content.value.title === '' && content.value.text === '') {
            formValidation.value = {
                validated: false,
                hasErrors: false,
                errors: {
                    title: [],
                    text: []
                }
            }
        } else {
            validate('title')
            validate('text')
        }
    },
    { immediate: true }
)

return { __sfc: true,props, content, submitInProgress, schema, formValidation, validate, handleKeyUp, submitButtonText, handleTitleKeyUp, submit, TmButton, TmRichTextEditor }
}

})